"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var defaultProps = {
    TextComponent: 'span',
    uppercase: false,
    escapeHTML: false,
    stripHTML: false
};
var LocaleString = function (_a) {
    var code = _a.code, escapeHTML = _a.escapeHTML, stripHTML = _a.stripHTML, translatedString = _a.translatedString, replaceOptions = _a.replaceOptions, TextComponent = _a.TextComponent, uppercase = _a.uppercase, dispatch = _a.dispatch, // react-redux connect injects this prop, don't pass it on to the TextComponent
    props = tslib_1.__rest(_a, ["code", "escapeHTML", "stripHTML", "translatedString", "replaceOptions", "TextComponent", "uppercase", "dispatch"]);
    var content = stripHTML ? translatedString.replace(/<(?:.|\n)*?>/gm, '') : translatedString;
    content = uppercase ? content.toUpperCase() : content;
    return escapeHTML ?
        react_1.default.createElement(TextComponent, tslib_1.__assign({ "data-key": code }, props), content)
        :
            react_1.default.createElement(TextComponent, tslib_1.__assign({ "data-key": code, dangerouslySetInnerHTML: { __html: content } }, props));
};
LocaleString.defaultProps = defaultProps;
exports.default = LocaleString;
//# sourceMappingURL=locale-string.js.map